import React from 'react';
import FormButton from '@ui/button/FormButton';
import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

/**
 * The Full width switch of the Date based table.
 * It shows from the xl breakpoint (1,280 px), where the page width limit binds. The label names the state.
 */
const FullWidthTableButton: React.FunctionComponent<{
	isFullWidth: boolean,
	onToggle: () => void,
}> = ({ isFullWidth, onToggle }) =>
	<FormButton state="white" extraClassName="hidden xl:inline-flex font-normal py-1.5" onClick={onToggle}
							icon={isFullWidth
								? <ArrowsPointingInIcon className="h-4 w-4" aria-hidden="true" />
								: <ArrowsPointingOutIcon className="h-4 w-4" aria-hidden="true" />}>
		{isFullWidth ? 'Default width' : 'Full width'}
	</FormButton>;

export default FullWidthTableButton;
